import ConditionType from './ConditionType'

const DivergingCondition: ConditionType = {
  value: 'diverging',
  label: 'Diverging',
  hasRHS: true,
}

export default DivergingCondition
